import Vue from 'vue';
import _ from 'lodash';

export default Vue.component('edit-list-menu', {
  template: require('./template.html'),
  name: 'edit-list-menu',
  props: ['droplet', 'show-edit-bubble', 'menu'],
  data() {
    return {
      order: [],
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValies();
      }
    },
  },
  methods: {
    setInitialValies() {
      this.order = this.getOrder();
    },
    dropCategory(params) {
      const order = this.droplet.order;
      this.$store.dispatch('runStateFn', {
        fn() {
          order.splice(params.newIndex, 0, order.splice(params.oldIndex, 1)[0]);
        },
      });
    },
    getOrder() {
      let categories = _.cloneDeep(this.menu.items);
      let order = _.cloneDeep(this.droplet.order);
      categories = Object.keys(categories);
      if (order.length < 2 && categories.length > 1) {
        order = categories;
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          key: 'order',
          val: order,
        });
      }
      if (order.length > 1 && !this.noOrderChange(categories)) {
        // remove order items if they don't exist in categories
        for (let i = order - 1; i >= 0; --i) {
          const item = order[i];
          if (!categories.includes(item)) {
            order.splice(i, 1);
            this.$store.dispatch('spliceDropletVal', {
              index: i,
              array: this.droplet.order,
            });
          }
        }
        // if a category is not in the order, need to add it
        for (let i = categories - 1; i >= 0; --i) {
          const cat = categories[i];
          if (!order.includes(cat)) {
            order.push(cat);
            this.$store.dispatch('pushDropletVal', {
              val: cat,
              array: this.droplet.order,
            });
          }
        }
      }
      return order;
    },
    noOrderChange(categories) {
      return _.isEqual(_.sortBy(this.droplet.order), _.sortBy(categories));
    },
    startCase(string) {
      return _.startCase(string);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/list-menu/components/_edit-options/index.js